import { getPropValue } from '@sportal365/smp-widget-utils';
import dayjs from 'dayjs';
import { Sports } from '../../../../packages/constants/sportType';
import { storybookEnvDataAsObject } from '../../../docs/.storybook/constants';

export const storybookEnvTennisWidgetData = storybookEnvDataAsObject.widgets.tennis;

export const getTennisWidgetPropValue = (widget: HTMLElement, name: string, configPropValue?: string) => {
  return getPropValue(Sports.TENNIS, dayjs, widget, name, configPropValue);
};
